import { createRouter, createWebHistory } from 'vue-router'
import JailRoster from '../components/JailRoster'

export const routes = [
    { path: '/', component: JailRoster, meta: { title: 'Kologik - Jail Roster' } },
]

let router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
